import React from 'react';

import Chip from 'material-ui/Chip';

import theme from '../../../muiTheme';

const DataGridHeader = props => {
  const badgeColor = props.badgeColor || theme.palette.primary1Color;
  const HEADER_STYLE = props.headerStyleOverride
    ? props.headerStyleOverride
    : styles.h2Style;

  return (
    <h2 style={HEADER_STYLE}>
      {props.title}
      <Chip
        style={styles.badgeStyle}
        labelStyle={styles.labelStyle}
        backgroundColor={badgeColor}
      >
        {props.itemCount.toLocaleString()}
      </Chip>
    </h2>
  );
};

const styles = {
  h2Style: {
    margin: '0 0 0 10px',
    fontWeight: 300
  },
  badgeStyle: {
    display: 'inline-block',
    verticalAlign: 'top',
    fontSize: '0.5em',
    marginLeft: '10px',
    top: '5px'
  },
  labelStyle: {
    color: theme.palette.alternateTextColor,
    fontSize: '12px',
    lineHeight: '24px',
    paddingLeft: '9px',
    paddingRight: '9px'
  }
};

export default DataGridHeader;



// WEBPACK FOOTER //
// ./src/components/common/DataGrid/DataGridHeader.js